const tokens = {
  "fonts.inter": {
    "value": "\"InterVariable\", Inter, Helvetica, Arial, sans-serif",
    "variable": "var(--hjqCdq)"
  },
  "fontSizes.display.xxl": {
    "value": "40px",
    "variable": "var(--hHxGqw)"
  },
  "fontSizes.display.xxl.tablet": {
    "value": "64px",
    "variable": "var(--csVZoj)"
  },
  "fontSizes.display.xl": {
    "value": "32px",
    "variable": "var(--UHPBc)"
  },
  "fontSizes.display.xl.tablet": {
    "value": "48px",
    "variable": "var(--eKIbEb)"
  },
  "fontSizes.display.l": {
    "value": "28px",
    "variable": "var(--gzKZKw)"
  },
  "fontSizes.display.l.tablet": {
    "value": "32px",
    "variable": "var(--flKYP)"
  },
  "fontSizes.title.l": {
    "value": "24px",
    "variable": "var(--kHSuym)"
  },
  "fontSizes.title.l.tablet": {
    "value": "28px",
    "variable": "var(--hrDQWl)"
  },
  "fontSizes.title.m": {
    "value": "24px",
    "variable": "var(--dyfSQL)"
  },
  "fontSizes.title.s": {
    "value": "20px",
    "variable": "var(--brlEGt)"
  },
  "fontSizes.title.xs": {
    "value": "18px",
    "variable": "var(--hoAPct)"
  },
  "fontSizes.body.xl": {
    "value": "16px",
    "variable": "var(--llWbwC)"
  },
  "fontSizes.body.l": {
    "value": "15px",
    "variable": "var(--jnkFam)"
  },
  "fontSizes.body.m": {
    "value": "14px",
    "variable": "var(--gpSNNb)"
  },
  "fontSizes.body.s": {
    "value": "13px",
    "variable": "var(--bTJpAl)"
  },
  "fontSizes.body.xs": {
    "value": "12px",
    "variable": "var(--eQVust)"
  },
  "fontSizes.caption.l": {
    "value": "11px",
    "variable": "var(--PAxxM)"
  },
  "fontSizes.caption.m": {
    "value": "10px",
    "variable": "var(--gUjdcR)"
  },
  "fontSizes.text.l": {
    "value": "16px",
    "variable": "var(--kmdpSX)"
  },
  "fontSizes.text.m": {
    "value": "14px",
    "variable": "var(--yPjm)"
  },
  "fontSizes.text.s": {
    "value": "12px",
    "variable": "var(--UQEHA)"
  },
  "fontSizes.text.xs": {
    "value": "11px",
    "variable": "var(--daYACg)"
  },
  "fontSizes.text.xxs": {
    "value": "10px",
    "variable": "var(--dLXPtc)"
  },
  "fontSizes.reactLegacy.display.xxl": {
    "value": "44px",
    "variable": "var(--eEJJJd)"
  },
  "fontSizes.reactLegacy.display.xxl.desktop": {
    "value": "64px",
    "variable": "var(--oAEfS)"
  },
  "fontSizes.reactLegacy.display.xl": {
    "value": "32px",
    "variable": "var(--hRDuFl)"
  },
  "fontSizes.reactLegacy.display.xl.desktop": {
    "value": "48px",
    "variable": "var(--gVfJzK)"
  },
  "fontSizes.reactLegacy.display.l": {
    "value": "28px",
    "variable": "var(--bxbVoh)"
  },
  "fontSizes.reactLegacy.display.l.desktop": {
    "value": "32px",
    "variable": "var(--dQPjbm)"
  },
  "fontSizes.reactLegacy.title.l": {
    "value": "24px",
    "variable": "var(--eFJHEn)"
  },
  "fontSizes.reactLegacy.title.l.desktop": {
    "value": "28px",
    "variable": "var(--hdwiTg)"
  },
  "fontSizes.reactLegacy.title.m": {
    "value": "24px",
    "variable": "var(--fjssHG)"
  },
  "fontSizes.reactLegacy.title.s": {
    "value": "20px",
    "variable": "var(--jTKcnM)"
  },
  "fontSizes.reactLegacy.title.xs": {
    "value": "18px",
    "variable": "var(--bPqdKs)"
  },
  "fontSizes.reactLegacy.text.l": {
    "value": "16px",
    "variable": "var(--hOIpsW)"
  },
  "fontSizes.reactLegacy.text.m": {
    "value": "14px",
    "variable": "var(--bghjej)"
  },
  "fontSizes.reactLegacy.text.s": {
    "value": "12px",
    "variable": "var(--gIBwbJ)"
  },
  "fontSizes.reactLegacy.text.xs": {
    "value": "11px",
    "variable": "var(--kMATNt)"
  },
  "fontSizes.reactLegacy.text.xxs": {
    "value": "10px",
    "variable": "var(--hDCiSh)"
  },
  "fontSizes.legacy.display": {
    "value": "48px",
    "variable": "var(--gnJumF)"
  },
  "fontSizes.legacy.display.tablet": {
    "value": "64px",
    "variable": "var(--ctClJC)"
  },
  "fontSizes.legacy.display.desktop": {
    "value": "96px",
    "variable": "var(--irtHCW)"
  },
  "fontSizes.legacy.h1": {
    "value": "32px",
    "variable": "var(--mKTFW)"
  },
  "fontSizes.legacy.h1.tablet": {
    "value": "48px",
    "variable": "var(--gNvgot)"
  },
  "fontSizes.legacy.h1.desktop": {
    "value": "64px",
    "variable": "var(--isWKph)"
  },
  "fontSizes.legacy.h2": {
    "value": "32px",
    "variable": "var(--csPWnR)"
  },
  "fontSizes.legacy.h2.tablet": {
    "value": "48px",
    "variable": "var(--eHqdGy)"
  },
  "fontSizes.legacy.h3": {
    "value": "24px",
    "variable": "var(--iiUCmE)"
  },
  "fontSizes.legacy.h3.tablet": {
    "value": "32px",
    "variable": "var(--khUAqP)"
  },
  "fontSizes.legacy.h4": {
    "value": "20px",
    "variable": "var(--kShFCP)"
  },
  "fontSizes.legacy.h4.tablet": {
    "value": "24px",
    "variable": "var(--hyHxaE)"
  },
  "fontSizes.legacy.h5": {
    "value": "18px",
    "variable": "var(--frDiSy)"
  },
  "fontSizes.legacy.h5.tablet": {
    "value": "20px",
    "variable": "var(--bICRbR)"
  },
  "fontSizes.legacy.h6": {
    "value": "16px",
    "variable": "var(--hxIlAt)"
  },
  "fontSizes.legacy.subHead": {
    "value": "12px",
    "variable": "var(--eStCZD)"
  },
  "fontSizes.legacy.subHead.tablet": {
    "value": "14px",
    "variable": "var(--jbgNEw)"
  },
  "fontSizes.legacy.body1": {
    "value": "16px",
    "variable": "var(--cMunqK)"
  },
  "fontSizes.legacy.body1.tablet": {
    "value": "18px",
    "variable": "var(--cIJdbV)"
  },
  "fontSizes.legacy.body2": {
    "value": "14px",
    "variable": "var(--iRihop)"
  },
  "fontSizes.legacy.body2.tablet": {
    "value": "16px",
    "variable": "var(--hTqSDm)"
  },
  "fontSizes.legacy.body3": {
    "value": "12px",
    "variable": "var(--bbjQpk)"
  },
  "fontSizes.legacy.caption": {
    "value": "10px",
    "variable": "var(--eeYhDh)"
  },
  "fontSizes.legacy.numberTitle": {
    "value": "24px",
    "variable": "var(--jUPFwU)"
  },
  "fontSizes.legacy.number1": {
    "value": "18px",
    "variable": "var(--beMYgp)"
  },
  "fontSizes.legacy.number1.tablet": {
    "value": "20px",
    "variable": "var(--fPBgeq)"
  },
  "fontSizes.legacy.number2": {
    "value": "14px",
    "variable": "var(--fmXGHq)"
  },
  "fontSizes.legacy.number2.tablet": {
    "value": "16px",
    "variable": "var(--bHqxDp)"
  },
  "fontSizes.legacy.number3": {
    "value": "12px",
    "variable": "var(--kHcMgn)"
  },
  "fontSizes.legacy.number3.tablet": {
    "value": "14px",
    "variable": "var(--hCHbDo)"
  },
  "fontSizes.legacy.number4": {
    "value": "10px",
    "variable": "var(--kdAbJw)"
  },
  "fontSizes.legacy.number4.tablet": {
    "value": "12px",
    "variable": "var(--igjMaf)"
  },
  "fontSizes.legacy.number16": {
    "value": "16px",
    "variable": "var(--hdxtyH)"
  },
  "fontSizes.legacy.number16.tablet": {
    "value": "18px",
    "variable": "var(--lbARbs)"
  },
  "fontSizes.legacy.number20": {
    "value": "20px",
    "variable": "var(--iAIJbW)"
  },
  "fontSizes.legacy.button1": {
    "value": "16px",
    "variable": "var(--dULaOY)"
  },
  "fontSizes.legacy.button2": {
    "value": "14px",
    "variable": "var(--dwjLlL)"
  },
  "fontSizes.legacy.button3": {
    "value": "12px",
    "variable": "var(--ivgDKW)"
  },
  "fontSizes.legacy.button4": {
    "value": "10px",
    "variable": "var(--jhJULt)"
  },
  "fontWeights.bold": {
    "value": 700,
    "variable": "var(--ghWdwL)"
  },
  "fontWeights.semiBold": {
    "value": 600,
    "variable": "var(--hmWxqp)"
  },
  "fontWeights.regular": {
    "value": 400,
    "variable": "var(--TgeWs)"
  },
  "letterSpacings.display.xxl": {
    "value": "-0.01em",
    "variable": "var(--cfPTR)"
  },
  "letterSpacings.display.xl": {
    "value": "-0.01em",
    "variable": "var(--hxrmh)"
  },
  "letterSpacings.display.l": {
    "value": "-0.005em",
    "variable": "var(--dfwXhJ)"
  },
  "letterSpacings.ls/-0.05em": {
    "value": "-0.05em",
    "variable": "var(--htiFcY)"
  },
  "letterSpacings.ls/-0.02em": {
    "value": "-0.02em",
    "variable": "var(--dIDWJX)"
  },
  "letterSpacings.ls/-0.01em": {
    "value": "-0.01em",
    "variable": "var(--guyEEw)"
  },
  "letterSpacings.ls/-0.015em": {
    "value": "-0.015em",
    "variable": "var(--kFKRGl)"
  },
  "letterSpacings.ls/-0.005em": {
    "value": "-0.005em",
    "variable": "var(--kVneEI)"
  },
  "letterSpacings.ls/0": {
    "value": "0",
    "variable": "var(--geoGeu)"
  },
  "letterSpacings.ls/0.005em": {
    "value": "0.005em",
    "variable": "var(--dhxgdB)"
  },
  "letterSpacings.ls/0.01em": {
    "value": "0.01em",
    "variable": "var(--cvVNLV)"
  },
  "letterSpacings.legacy.display.xxl": {
    "value": "-0.8px",
    "variable": "var(--jssgaN)"
  },
  "letterSpacings.legacy.display.xxl.desktop": {
    "value": "-1.28px",
    "variable": "var(--fXYbGi)"
  },
  "letterSpacings.legacy.display.xl": {
    "value": "-0.64px",
    "variable": "var(--dLcaHR)"
  },
  "letterSpacings.legacy.display.xl.desktop": {
    "value": "-0.96px",
    "variable": "var(--faYKfC)"
  },
  "letterSpacings.legacy.display.l": {
    "value": "-0.56px",
    "variable": "var(--gkKrFR)"
  },
  "letterSpacings.legacy.display.l.desktop": {
    "value": "-0.64px",
    "variable": "var(--jAmGBC)"
  },
  "letterSpacings.legacy.title.l": {
    "value": "-0.48px",
    "variable": "var(--evPMLz)"
  },
  "letterSpacings.legacy.title.l.desktop": {
    "value": "-0.56px",
    "variable": "var(--gQLOQA)"
  },
  "letterSpacings.legacy.title.m": {
    "value": "-0.48px",
    "variable": "var(--etTsji)"
  },
  "letterSpacings.legacy.title.s": {
    "value": "-0.4px",
    "variable": "var(--ifsTYQ)"
  },
  "letterSpacings.legacy.title.xs": {
    "value": "-0.36px",
    "variable": "var(--jqFwrg)"
  },
  "letterSpacings.legacy.text.l": {
    "value": "-0.24px",
    "variable": "var(--iJqXzC)"
  },
  "letterSpacings.legacy.text.m": {
    "value": "-0.21px",
    "variable": "var(--kjqrMz)"
  },
  "letterSpacings.legacy.text.s": {
    "value": "-0.18px",
    "variable": "var(--gBGeZJ)"
  },
  "letterSpacings.legacy.text.xs": {
    "value": "0",
    "variable": "var(--lnRxBB)"
  },
  "letterSpacings.legacy.text.xxs": {
    "value": "0",
    "variable": "var(--hwGRQh)"
  },
  "lineHeights.display.xxl": {
    "value": "120%",
    "variable": "var(--eyDUwz)"
  },
  "lineHeights.display.xl": {
    "value": "120%",
    "variable": "var(--BaDuj)"
  },
  "lineHeights.display.l": {
    "value": "120%",
    "variable": "var(--hlVEyX)"
  },
  "lineHeights.lh/150%": {
    "value": "150%",
    "variable": "var(--hjrwpe)"
  },
  "lineHeights.lh/140%": {
    "value": "140%",
    "variable": "var(--bZCisj)"
  },
  "lineHeights.lh/135%": {
    "value": "135%",
    "variable": "var(--czspCZ)"
  },
  "lineHeights.lh/120%": {
    "value": "120%",
    "variable": "var(--gMqtyN)"
  },
  "lineHeights.lh/112%": {
    "value": "112%",
    "variable": "var(--gbPznc)"
  },
  "lineHeights.lh/30px": {
    "value": "30px",
    "variable": "var(--eOemQI)"
  },
  "lineHeights.lh/28px": {
    "value": "28px",
    "variable": "var(--ccwxAl)"
  },
  "lineHeights.lh/24px": {
    "value": "24px",
    "variable": "var(--kDdVhZ)"
  },
  "lineHeights.lh/22px": {
    "value": "22px",
    "variable": "var(--dFYJwH)"
  },
  "lineHeights.lh/18px": {
    "value": "18px",
    "variable": "var(--gYCUCq)"
  },
  "lineHeights.lh/16px": {
    "value": "16px",
    "variable": "var(--izFZiE)"
  },
  "lineHeights.lh/14px": {
    "value": "14px",
    "variable": "var(--ejOILi)"
  },
  "lineHeights.lh/12px": {
    "value": "12px",
    "variable": "var(--ibvLpo)"
  },
  "lineHeights.legacy.display": {
    "value": "0.95",
    "variable": "var(--fkzwAa)"
  },
  "lineHeights.legacy.heading": {
    "value": "1.1",
    "variable": "var(--isSPII)"
  },
  "lineHeights.legacy.body": {
    "value": "1.4",
    "variable": "var(--goPKHU)"
  },
  "lineHeights.legacy.caption": {
    "value": "1.3",
    "variable": "var(--krnlgu)"
  },
  "lineHeights.legacy.number20": {
    "value": "1",
    "variable": "var(--jZvLSZ)"
  },
  "lineHeights.legacy.number20.tablet": {
    "value": "1.4",
    "variable": "var(--dhWwxO)"
  },
  "lineHeights.legacy.button": {
    "value": "1.1",
    "variable": "var(--dznpCK)"
  },
  "colors.blue.50": {
    "value": "#0B1F33",
    "variable": "var(--glmLoi)"
  },
  "colors.blue.100": {
    "value": "#0D2A46",
    "variable": "var(--bYrJpO)"
  },
  "colors.blue.200": {
    "value": "#123B5F",
    "variable": "var(--hoTvPd)"
  },
  "colors.blue.300": {
    "value": "#18507E",
    "variable": "var(--bMEoOM)"
  },
  "colors.blue.400": {
    "value": "#1F66A8",
    "variable": "var(--hIEEwj)"
  },
  "colors.blue.500": {
    "value": "#0A84FF",
    "variable": "var(--cgpxvS)"
  },
  "colors.blue.600": {
    "value": "#2F98FF",
    "variable": "var(--hwRjVh)"
  },
  "colors.blue.700": {
    "value": "#56ACFF",
    "variable": "var(--bUCcUQ)"
  },
  "colors.blue.800": {
    "value": "#84C4FF",
    "variable": "var(--golFsv)"
  },
  "colors.blue.900": {
    "value": "#B3DDFF",
    "variable": "var(--LWyse)"
  },
  "colors.gray.0": {
    "value": "#111111",
    "variable": "var(--hWpGKg)"
  },
  "colors.gray.25": {
    "value": "#1C1C1C",
    "variable": "var(--gXthDn)"
  },
  "colors.gray.50": {
    "value": "#232323",
    "variable": "var(--dcmCJN)"
  },
  "colors.gray.100": {
    "value": "#2C2C2C",
    "variable": "var(--ePJGsV)"
  },
  "colors.gray.150": {
    "value": "#363636",
    "variable": "var(--kezcqs)"
  },
  "colors.gray.200": {
    "value": "#424242",
    "variable": "var(--dnVpUm)"
  },
  "colors.gray.300": {
    "value": "#505050",
    "variable": "var(--bMJKSL)"
  },
  "colors.gray.400": {
    "value": "#636363",
    "variable": "var(--jSiOQk)"
  },
  "colors.gray.500": {
    "value": "#7B7B7B",
    "variable": "var(--iqXjOJ)"
  },
  "colors.gray.600": {
    "value": "#959595",
    "variable": "var(--gPiTqa)"
  },
  "colors.gray.700": {
    "value": "#B4B4B4",
    "variable": "var(--fnXooz)"
  },
  "colors.gray.800": {
    "value": "#D4D4D4",
    "variable": "var(--fKIyfA)"
  },
  "colors.gray.900": {
    "value": "#F7F7F7",
    "variable": "var(--ejwTdZ)"
  },
  "colors.gray.white": {
    "value": "#ffffff",
    "variable": "var(--hoiJub)"
  },
  "colors.gray.black": {
    "value": "#000000",
    "variable": "var(--jXCDIP)"
  },
  "colors.red.50": {
    "value": "#291111",
    "variable": "var(--bINrJX)"
  },
  "colors.red.100": {
    "value": "#431514",
    "variable": "var(--fKgVwH)"
  },
  "colors.red.200": {
    "value": "#581e1a",
    "variable": "var(--bLdQLg)"
  },
  "colors.red.300": {
    "value": "#7c241f",
    "variable": "var(--fMUQaR)"
  },
  "colors.red.400": {
    "value": "#ac2c25",
    "variable": "var(--hwCQam)"
  },
  "colors.red.500": {
    "value": "#ff493f",
    "variable": "var(--iYfRb)"
  },
  "colors.red.600": {
    "value": "#ff6759",
    "variable": "var(--hzqKEw)"
  },
  "colors.red.700": {
    "value": "#ff9182",
    "variable": "var(--lMavl)"
  },
  "colors.red.800": {
    "value": "#ffb7ab",
    "variable": "var(--bLDcWa)"
  },
  "colors.red.900": {
    "value": "#ffdcd4",
    "variable": "var(--fNuclL)"
  },
  "colors.yellow.50": {
    "value": "#281e0e",
    "variable": "var(--cLFWMs)"
  },
  "colors.yellow.100": {
    "value": "#422f0e",
    "variable": "var(--kxGpio)"
  },
  "colors.yellow.200": {
    "value": "#574012",
    "variable": "var(--cbZZGT)"
  },
  "colors.yellow.300": {
    "value": "#7a5712",
    "variable": "var(--fwcFBW)"
  },
  "colors.yellow.400": {
    "value": "#a87613",
    "variable": "var(--hUTJsd)"
  },
  "colors.yellow.500": {
    "value": "#faad14",
    "variable": "var(--loWpng)"
  },
  "colors.yellow.600": {
    "value": "#ffc53d",
    "variable": "var(--cTpZLL)"
  },
  "colors.yellow.700": {
    "value": "#ffd666",
    "variable": "var(--gnsFGO)"
  },
  "colors.yellow.800": {
    "value": "#ffe58f",
    "variable": "var(--ByZWN)"
  },
  "colors.yellow.900": {
    "value": "#fff1b8",
    "variable": "var(--dVBFRQ)"
  },
  "colors.green.50": {
    "value": "#112116",
    "variable": "var(--hXozqf)"
  },
  "colors.green.100": {
    "value": "#15351e",
    "variable": "var(--iDDIAz)"
  },
  "colors.green.200": {
    "value": "#1c4827",
    "variable": "var(--khfuXU)"
  },
  "colors.green.300": {
    "value": "#216331",
    "variable": "var(--hypAVx)"
  },
  "colors.green.400": {
    "value": "#288740",
    "variable": "var(--wGfza)"
  },
  "colors.green.500": {
    "value": "#34c759",
    "variable": "var(--jdlUVz)"
  },
  "colors.green.600": {
    "value": "#59d474",
    "variable": "var(--kGNHsU)"
  },
  "colors.green.700": {
    "value": "#82e093",
    "variable": "var(--hXXNqx)"
  },
  "colors.green.800": {
    "value": "#afedb9",
    "variable": "var(--bAQeLK)"
  },
  "colors.green.900": {
    "value": "#e1fae4",
    "variable": "var(--khvUij)"
  },
  "colors.indigo.50": {
    "value": "#121524",
    "variable": "var(--kbclAu)"
  },
  "colors.indigo.100": {
    "value": "#171f3b",
    "variable": "var(--gAzkHe)"
  },
  "colors.indigo.200": {
    "value": "#1f2a4e",
    "variable": "var(--gRHwoJ)"
  },
  "colors.indigo.300": {
    "value": "#25366d",
    "variable": "var(--iYtjYI)"
  },
  "colors.indigo.400": {
    "value": "#2e4696",
    "variable": "var(--jCTsMf)"
  },
  "colors.indigo.500": {
    "value": "#3e63dd",
    "variable": "var(--ujwXi)"
  },
  "colors.indigo.600": {
    "value": "#678aeb",
    "variable": "var(--LrIEN)"
  },
  "colors.indigo.700": {
    "value": "#94b2f7",
    "variable": "var(--cSdwoM)"
  },
  "colors.indigo.800": {
    "value": "#c2d6ff",
    "variable": "var(--irwviH)"
  },
  "colors.indigo.900": {
    "value": "#ebf2ff",
    "variable": "var(--kyiiSG)"
  },
  "colors.lime.50": {
    "value": "#1f2600",
    "variable": "var(--dhEleJ)"
  },
  "colors.lime.100": {
    "value": "#313a00",
    "variable": "var(--gFFbyh)"
  },
  "colors.lime.200": {
    "value": "#4b5700",
    "variable": "var(--fjFsBy)"
  },
  "colors.lime.300": {
    "value": "#6e7f00",
    "variable": "var(--cfdGZz)"
  },
  "colors.lime.400": {
    "value": "#9fb800",
    "variable": "var(--bxLPEk)"
  },
  "colors.lime.500": {
    "value": "#cfe600",
    "variable": "var(--jIFNBh)"
  },
  "colors.lime.600": {
    "value": "#edff00",
    "variable": "var(--imGeEy)"
  },
  "colors.lime.700": {
    "value": "#eeff66",
    "variable": "var(--fietcz)"
  },
  "colors.lime.800": {
    "value": "#f6ffaa",
    "variable": "var(--crovfQ)"
  },
  "colors.lime.900": {
    "value": "#fcffdd",
    "variable": "var(--kCitcN)"
  },
  "colors.legacy.blue": {
    "value": "#0a84ff",
    "variable": "var(--khcUsy)"
  },
  "colors.legacy.blue.ex": {
    "value": "#086acc",
    "variable": "var(--jgzsIi)"
  },
  "colors.legacy.blue.dark": {
    "value": "#23539e",
    "variable": "var(--lkNwpf)"
  },
  "colors.legacy.blue.light": {
    "value": "#6ca2e8",
    "variable": "var(--evqrhx)"
  },
  "colors.legacy.red": {
    "value": "#ff4141",
    "variable": "var(--fcnzLz)"
  },
  "colors.legacy.red.hover": {
    "value": "#eb0000",
    "variable": "var(--hCwAOg)"
  },
  "colors.legacy.green": {
    "value": "#34c759",
    "variable": "var(--jbgqdj)"
  },
  "colors.legacy.green.dark": {
    "value": "#3f7d41",
    "variable": "var(--cbirYC)"
  },
  "colors.legacy.green.light": {
    "value": "#85ca8b",
    "variable": "var(--jncbwU)"
  },
  "colors.legacy.green.hover": {
    "value": "#299f47",
    "variable": "var(--aHMhc)"
  },
  "colors.legacy.yellow": {
    "value": "#ffb241",
    "variable": "var(--iLZigI)"
  },
  "colors.legacy.yellow.dark": {
    "value": "#9c7438",
    "variable": "var(--cpWoId)"
  },
  "colors.legacy.yellow.light": {
    "value": "#e8c080",
    "variable": "var(--kVlgb)"
  },
  "colors.legacy.gray.1": {
    "value": "#111111",
    "variable": "var(--gGRolZ)"
  },
  "colors.legacy.gray.2": {
    "value": "#252525",
    "variable": "var(--liVZeS)"
  },
  "colors.legacy.gray.3": {
    "value": "#333333",
    "variable": "var(--jlxQKD)"
  },
  "colors.legacy.gray.4": {
    "value": "#4c4c4c",
    "variable": "var(--equsNE)"
  },
  "colors.legacy.gray.8": {
    "value": "#8c8c8c",
    "variable": "var(--dcccIE)"
  },
  "colors.legacy.gray.23": {
    "value": "#232323",
    "variable": "var(--cSmJQh)"
  },
  "colors.legacy.gray.1c": {
    "value": "#1c1c1e",
    "variable": "var(--imvLiC)"
  },
  "colors.legacy.gray.d": {
    "value": "#dddddd",
    "variable": "var(--bpgdAc)"
  },
  "colors.legacy.gray.e": {
    "value": "#eeeeee",
    "variable": "var(--dErDAd)"
  },
  "colors.legacy.social.discord": {
    "value": "#5865f2",
    "variable": "var(--cuzChG)"
  },
  "colors.legacy.social.telegram": {
    "value": "#25a4e2",
    "variable": "var(--dJPCxD)"
  },
  "colors.legacy.social.twitter": {
    "value": "#00aeef",
    "variable": "var(--kIAATX)"
  },
  "colors.legacy.gradient.purple": {
    "value": "#3d02e8",
    "variable": "var(--fBVwsZ)"
  },
  "colors.legacy.gradient.pink": {
    "value": "#cb00ff",
    "variable": "var(--dtjmIb)"
  },
  "colors.legacy.purple": {
    "value": "#4a0aff",
    "variable": "var(--ewquea)"
  },
  "gradients.gold": {
    "value": "linear-gradient(var(--gradient-angle, 135deg), #E4AF5B 0%, #FFCC7B 10%, #FFF6E9 30%, #FFF6E9 40%, #FFCC7B 59.5%, #E4AF5B 100%)",
    "variable": "var(--kalFXz)"
  },
  "gradients.purple": {
    "value": "linear-gradient(var(--gradient-angle, 82deg), var(--itLqyf) 11.96%, var(--kAOKli) 50%, var(--kswjMF) 88.04%)",
    "variable": "var(--hHbxkB)"
  },
  "zIndex.tooltip": {
    "value": 700,
    "variable": "var(--hVmPBT)"
  },
  "zIndex.alertBanner": {
    "value": 800,
    "variable": "var(--dZaGBA)"
  },
  "zIndex.gnb": {
    "value": 900,
    "variable": "var(--fKqKFB)"
  },
  "zIndex.modal": {
    "value": 1000,
    "variable": "var(--dIktSh)"
  },
  "zIndex.toast": {
    "value": 10000,
    "variable": "var(--BtcyX)"
  },
  "zIndex.alert": {
    "value": 10000,
    "variable": "var(--gkJIHU)"
  },
  "sizes.legacyMobileSmallHeight": {
    "value": "26px",
    "variable": "var(--JVAAJ)"
  },
  "sizes.legacyMobileMediumHeight": {
    "value": "36px",
    "variable": "var(--dVfGez)"
  },
  "sizes.legacyMobileLargeHeight": {
    "value": "46px",
    "variable": "var(--iVkSOj)"
  },
  "sizes.legacyDesktopSmallHeight": {
    "value": "30px",
    "variable": "var(--eLJsgb)"
  },
  "sizes.legacyDesktopMediumHeight": {
    "value": "40px",
    "variable": "var(--emjUqB)"
  },
  "sizes.legacyDesktopLargeHeight": {
    "value": "50px",
    "variable": "var(--caLsCR)"
  },
  "sizes.legacyMinDataSectionHeight": {
    "value": "280px",
    "variable": "var(--kLAiJR)"
  },
  "sizes.legacyMobileMaxWidth": {
    "value": "768px",
    "variable": "var(--PnNUr)"
  },
  "sizes.legacyHdMaxWidth": {
    "value": "1194px",
    "variable": "var(--kHMdvb)"
  },
  "sizes.legacyNavHeight": {
    "value": "60px",
    "variable": "var(--dLeldb)"
  },
  "sizes.legacyWebviewNavHeight": {
    "value": "40px",
    "variable": "var(--gaWihe)"
  },
  "sizes.legacyTopBannerHeight": {
    "value": "48px",
    "variable": "var(--jZImhF)"
  },
  "sizes.legacyDesktopFooterHeight": {
    "value": "350px",
    "variable": "var(--cwVYtN)"
  },
  "sizes.mobileMaxWidth": {
    "value": "768px",
    "variable": "var(--LxJda)"
  },
  "sizes.desktopMaxWidth": {
    "value": "1200px",
    "variable": "var(--ikDwIw)"
  },
  "sizes.gnbHeight": {
    "value": "60px",
    "variable": "var(--hUEsfg)"
  },
  "sizes.footerHeight": {
    "value": "350px",
    "variable": "var(--bjqhXa)"
  },
  "sizes.navigationHeight": {
    "value": "var(--current-navigation-height, var(--hUEsfg))",
    "variable": "var(--bTuvpV)"
  },
  "sizes.minHeightWithoutNavigation": {
    "value": "calc(100dvh - var(--bTuvpV))",
    "variable": "var(--cbChXP)"
  },
  "sizes.minHeightWithoutNavigationAndFooter": {
    "value": "calc(var(--cbChXP) - var(--bjqhXa))",
    "variable": "var(--cRByHp)"
  },
  "sizes.alertBannerMobileHeight": {
    "value": "64px",
    "variable": "var(--kmsNGl)"
  },
  "sizes.alertBannerAfterMobileHeight": {
    "value": "48px",
    "variable": "var(--dybRNd)"
  },
  "sizes.breakpoint-tablet": {
    "value": "768px",
    "variable": "var(--iCtdVo)"
  },
  "sizes.breakpoint-smallDesktop": {
    "value": "1280px",
    "variable": "var(--fCVoQf)"
  },
  "sizes.breakpoint-largeDesktop": {
    "value": "1920px",
    "variable": "var(--gSqywx)"
  },
  "breakpoints.tablet": {
    "value": "768px",
    "variable": "var(--iNvcGI)"
  },
  "breakpoints.smallDesktop": {
    "value": "1280px",
    "variable": "var(--kDCmUT)"
  },
  "breakpoints.largeDesktop": {
    "value": "1920px",
    "variable": "var(--fenylR)"
  },
  "colors.content.default.level-0": {
    "value": "var(--jSiOQk)",
    "variable": "var(--bfLkuF)"
  },
  "colors.content.default.level-1": {
    "value": "var(--iqXjOJ)",
    "variable": "var(--fCvcsM)"
  },
  "colors.content.default.level-2": {
    "value": "var(--gPiTqa)",
    "variable": "var(--eXZFJb)"
  },
  "colors.content.default.level-3": {
    "value": "var(--fnXooz)",
    "variable": "var(--juJxHi)"
  },
  "colors.content.default.level-4": {
    "value": "var(--fKIyfA)",
    "variable": "var(--kDZSIJ)"
  },
  "colors.content.default.level-5": {
    "value": "var(--ejwTdZ)",
    "variable": "var(--dLobhU)"
  },
  "colors.content.accent.info": {
    "value": "var(--hwRjVh)",
    "variable": "var(--hDgqZJ)"
  },
  "colors.content.accent.info.hover": {
    "value": "var(--hIEEwj)",
    "variable": "var(--zUyme)"
  },
  "colors.content.accent.sell": {
    "value": "var(--iYfRb)",
    "variable": "var(--mhWnd)"
  },
  "colors.content.accent.sell.hover": {
    "value": "var(--hwCQam)",
    "variable": "var(--dACEXy)"
  },
  "colors.content.accent.new": {
    "value": "var(--iYfRb)",
    "variable": "var(--jYzlNr)"
  },
  "colors.content.accent.new.hover": {
    "value": "var(--hwCQam)",
    "variable": "var(--dHlRjc)"
  },
  "colors.content.accent.buy": {
    "value": "var(--jdlUVz)",
    "variable": "var(--eqVfWV)"
  },
  "colors.content.accent.buy.hover": {
    "value": "var(--wGfza)",
    "variable": "var(--eaVAAS)"
  },
  "colors.content.accent.promotion": {
    "value": "var(--jIFNBh)",
    "variable": "var(--fnRYXU)"
  },
  "colors.content.accent.promotion.hover": {
    "value": "var(--cfdGZz)",
    "variable": "var(--iFXsiP)"
  },
  "colors.content.accent.VIP": {
    "value": "#ffe6a8",
    "variable": "var(--eGmHWo)"
  },
  "colors.content.state.negative": {
    "value": "var(--iYfRb)",
    "variable": "var(--jfuwPh)"
  },
  "colors.content.state.negative.hover": {
    "value": "var(--hwCQam)",
    "variable": "var(--iYPYuG)"
  },
  "colors.content.state.positive": {
    "value": "var(--jdlUVz)",
    "variable": "var(--eHJUCJ)"
  },
  "colors.content.state.positive.hover": {
    "value": "var(--wGfza)",
    "variable": "var(--dtZAmi)"
  },
  "colors.content.state.warning": {
    "value": "var(--loWpng)",
    "variable": "var(--hIkZEQ)"
  },
  "colors.content.state.warning.hover": {
    "value": "var(--hUTJsd)",
    "variable": "var(--cnKmOz)"
  },
  "colors.content.interaction.hover": {
    "value": "rgba(255, 255, 255, 0.32)",
    "variable": "var(--gxoIYl)"
  },
  "colors.content.interaction.disabled": {
    "value": "rgba(255, 255, 255, 0.16)",
    "variable": "var(--jkyElP)"
  },
  "colors.content.legacy.default.level-0": {
    "value": "var(--jXCDIP)",
    "variable": "var(--fiaoYp)"
  },
  "colors.content.legacy.default.level-1": {
    "value": "var(--iqXjOJ)",
    "variable": "var(--fjxxbY)"
  },
  "colors.content.legacy.default.level-2": {
    "value": "var(--gPiTqa)",
    "variable": "var(--hDzvaf)"
  },
  "colors.content.legacy.default.level-3": {
    "value": "var(--fnXooz)",
    "variable": "var(--hEWDdO)"
  },
  "colors.content.legacy.default.level-4": {
    "value": "var(--ejwTdZ)",
    "variable": "var(--jBLObF)"
  },
  "colors.content.legacy.default.level-5": {
    "value": "var(--hoiJub)",
    "variable": "var(--jDiWfo)"
  },
  "colors.content.legacy.accent.info": {
    "value": "var(--cgpxvS)",
    "variable": "var(--jDkpuN)"
  },
  "colors.content.legacy.accent.promotion": {
    "value": "var(--cSdwoM)",
    "variable": "var(--fGrGyA)"
  },
  "colors.content.legacy.accent.vip": {
    "value": "#FFE6A8",
    "variable": "var(--ghfFHI)"
  },
  "colors.content.legacy.state.negative": {
    "value": "var(--iYfRb)",
    "variable": "var(--fLswhx)"
  },
  "colors.content.legacy.state.positive": {
    "value": "var(--jdlUVz)",
    "variable": "var(--bTpwtV)"
  },
  "colors.content.legacy.state.warning": {
    "value": "var(--loWpng)",
    "variable": "var(--jDoYJo)"
  },
  "colors.content.legacy.interaction.hover": {
    "value": "var(--iqXjOJ)",
    "variable": "var(--jvBodp)"
  },
  "colors.content.legacy.interaction.disabled": {
    "value": "var(--bMJKSL)",
    "variable": "var(--kZTqHP)"
  },
  "colors.background.default.level-0": {
    "value": "var(--hWpGKg)",
    "variable": "var(--fiJNkW)"
  },
  "colors.background.default.level-1": {
    "value": "var(--gXthDn)",
    "variable": "var(--fnJhrf)"
  },
  "colors.background.default.level-2": {
    "value": "var(--dcmCJN)",
    "variable": "var(--cNAcMs)"
  },
  "colors.background.default.level-3": {
    "value": "var(--ePJGsV)",
    "variable": "var(--cSzwSB)"
  },
  "colors.background.default.level-4": {
    "value": "var(--dnVpUm)",
    "variable": "var(--hBjDUe)"
  },
  "colors.background.accent.primary": {
    "value": "var(--cgpxvS)",
    "variable": "var(--jmegbg)"
  },
  "colors.background.accent.primary.hover": {
    "value": "var(--hIEEwj)",
    "variable": "var(--joKfSr)"
  },
  "colors.background.accent.primary.tint": {
    "value": "rgba(10, 132, 255, 0.16)",
    "variable": "var(--kGULBe)"
  },
  "colors.background.accent.secondary": {
    "value": "var(--ejwTdZ)",
    "variable": "var(--dyzEZW)"
  },
  "colors.background.accent.secondary.hover": {
    "value": "var(--fnXooz)",
    "variable": "var(--JPMXt)"
  },
  "colors.background.accent.secondary.tint": {
    "value": "rgba(247, 247, 247, 0.1)",
    "variable": "var(--etveWM)"
  },
  "colors.background.accent.secondary.tint.hover": {
    "value": "rgba(247, 247, 247, 0.05)",
    "variable": "var(--kETsRX)"
  },
  "colors.background.accent.sell": {
    "value": "var(--iYfRb)",
    "variable": "var(--hOcjDm)"
  },
  "colors.background.accent.sell.hover": {
    "value": "var(--hwCQam)",
    "variable": "var(--icuBIt)"
  },
  "colors.background.accent.sell.tint": {
    "value": "rgba(255, 73, 63, 0.12)",
    "variable": "var(--itzqWk)"
  },
  "colors.background.accent.new.tint": {
    "value": "rgba(255, 73, 63, 0.12)",
    "variable": "var(--kPXHsi)"
  },
  "colors.background.accent.buy": {
    "value": "var(--jdlUVz)",
    "variable": "var(--xZKwG)"
  },
  "colors.background.accent.buy.hover": {
    "value": "var(--wGfza)",
    "variable": "var(--dqMgtx)"
  },
  "colors.background.accent.buy.tint": {
    "value": "rgba(52, 199, 89, 0.12)",
    "variable": "var(--fupVfE)"
  },
  "colors.background.accent.promotion.tint": {
    "value": "rgba(237, 255, 0, 0.06)",
    "variable": "var(--fILgvR)"
  },
  "colors.background.state.negative.tint": {
    "value": "rgba(255, 73, 63, 0.12)",
    "variable": "var(--hoGmAo)"
  },
  "colors.background.state.positive.tint": {
    "value": "rgba(52, 199, 89, 0.12)",
    "variable": "var(--hAgQdI)"
  },
  "colors.background.state.warning.tint": {
    "value": "rgba(250, 173, 20, 0.12)",
    "variable": "var(--cTNuwh)"
  },
  "colors.background.interaction.hover": {
    "value": "rgba(255, 255, 255, 0.1)",
    "variable": "var(--ePjnpy)"
  },
  "colors.background.interaction.disabled": {
    "value": "rgba(255, 255, 255, 0.08)",
    "variable": "var(--fwtPGs)"
  },
  "colors.background.interaction.dim": {
    "value": "rgba(0, 0, 0, 0.7)",
    "variable": "var(--iagDBg)"
  },
  "colors.background.legacy.default.level-0": {
    "value": "var(--hWpGKg)",
    "variable": "var(--fDkxBe)"
  },
  "colors.background.legacy.default.level-1": {
    "value": "var(--gXthDn)",
    "variable": "var(--lfzLHn)"
  },
  "colors.background.legacy.default.level-2": {
    "value": "var(--ePJGsV)",
    "variable": "var(--jEKifU)"
  },
  "colors.background.legacy.default.level-3": {
    "value": "var(--dnVpUm)",
    "variable": "var(--dRDMNh)"
  },
  "colors.background.legacy.default.level-4": {
    "value": "var(--hoiJub)",
    "variable": "var(--epikWu)"
  },
  "colors.background.legacy.accent.primary": {
    "value": "var(--cgpxvS)",
    "variable": "var(--MpBwA)"
  },
  "colors.background.legacy.accent.primary.hover": {
    "value": "var(--hIEEwj)",
    "variable": "var(--iSMBSj)"
  },
  "colors.background.legacy.accent.secondary": {
    "value": "var(--ejwTdZ)",
    "variable": "var(--cYufPq)"
  },
  "colors.background.legacy.accent.secondary.hover": {
    "value": "var(--fnXooz)",
    "variable": "var(--ghZeXR)"
  },
  "colors.background.legacy.accent.buy": {
    "value": "var(--jdlUVz)",
    "variable": "var(--dwuQQy)"
  },
  "colors.background.legacy.accent.buy.hover": {
    "value": "var(--wGfza)",
    "variable": "var(--fStfFp)"
  },
  "colors.background.legacy.accent.sell": {
    "value": "var(--iYfRb)",
    "variable": "var(--ggayxS)"
  },
  "colors.background.legacy.accent.sell.hover": {
    "value": "var(--hwCQam)",
    "variable": "var(--gCtgNh)"
  },
  "colors.background.legacy.interaction.hover": {
    "value": "rgba(255, 255, 255, 0.1)",
    "variable": "var(--iCBjlG)"
  },
  "colors.background.legacy.interaction.disabled": {
    "value": "var(--dcmCJN)",
    "variable": "var(--ddmBBo)"
  },
  "colors.background.legacy.interaction.dim": {
    "value": "rgba(0, 0, 0, 0.6)",
    "variable": "var(--dxzQZo)"
  },
  "colors.border.default.level-1": {
    "value": "var(--ePJGsV)",
    "variable": "var(--hjTMnN)"
  },
  "colors.border.default.level-2": {
    "value": "var(--kezcqs)",
    "variable": "var(--cROeIa)"
  },
  "colors.border.default.level-3": {
    "value": "var(--dnVpUm)",
    "variable": "var(--bVkQln)"
  },
  "colors.border.default.level-4": {
    "value": "var(--bMJKSL)",
    "variable": "var(--bmQsVc)"
  },
  "colors.border.default.level-5": {
    "value": "var(--fnXooz)",
    "variable": "var(--qneyp)"
  },
  "colors.border.accent.info": {
    "value": "var(--hIEEwj)",
    "variable": "var(--djnWk)"
  },
  "colors.border.accent.info.hover": {
    "value": "var(--bMEoOM)",
    "variable": "var(--dDDdPT)"
  },
  "colors.border.accent.sell": {
    "value": "var(--fMUQaR)",
    "variable": "var(--czqqdM)"
  },
  "colors.border.accent.sell.hover": {
    "value": "var(--bLdQLg)",
    "variable": "var(--bcriOj)"
  },
  "colors.border.accent.new": {
    "value": "var(--fMUQaR)",
    "variable": "var(--fpaeRm)"
  },
  "colors.border.accent.new.hover": {
    "value": "var(--bLdQLg)",
    "variable": "var(--bHvSuZ)"
  },
  "colors.border.accent.buy": {
    "value": "var(--hypAVx)",
    "variable": "var(--jCzMYs)"
  },
  "colors.border.accent.buy.hover": {
    "value": "var(--khfuXU)",
    "variable": "var(--fgnEcj)"
  },
  "colors.border.accent.promotion": {
    "value": "var(--cfdGZz)",
    "variable": "var(--fxTBzd)"
  },
  "colors.border.accent.promotion.hover": {
    "value": "var(--fjFsBy)",
    "variable": "var(--bQRGIK)"
  },
  "colors.border.state.negative": {
    "value": "var(--fMUQaR)",
    "variable": "var(--bNOjpc)"
  },
  "colors.border.state.positive": {
    "value": "var(--hypAVx)",
    "variable": "var(--bXemQo)"
  },
  "colors.border.state.warning": {
    "value": "var(--fwcFBW)",
    "variable": "var(--IVIHJ)"
  },
  "colors.border.interaction.hover": {
    "value": "rgba(255, 255, 255, 0.16)",
    "variable": "var(--hBdxJQ)"
  },
  "colors.border.interaction.disabled": {
    "value": "rgba(255, 255, 255, 0.08)",
    "variable": "var(--jKUeKq)"
  },
  "colors.border.legacy.default.level-1": {
    "value": "var(--ePJGsV)",
    "variable": "var(--dbbgqZ)"
  },
  "colors.border.legacy.default.level-2": {
    "value": "var(--dnVpUm)",
    "variable": "var(--IHidu)"
  },
  "colors.border.legacy.default.level-3": {
    "value": "var(--bMJKSL)",
    "variable": "var(--btTQcj)"
  },
  "colors.border.legacy.default.level-4": {
    "value": "var(--fnXooz)",
    "variable": "var(--dRhFrs)"
  },
  "colors.border.legacy.accent.short": {
    "value": "var(--fMUQaR)",
    "variable": "var(--gAQPcg)"
  },
  "colors.border.legacy.accent.long": {
    "value": "var(--hypAVx)",
    "variable": "var(--eaqLpk)"
  },
  "colors.border.legacy.state.negative": {
    "value": "var(--iYfRb)",
    "variable": "var(--ecwbbc)"
  },
  "colors.border.legacy.interaction.disabled": {
    "value": "var(--gXthDn)",
    "variable": "var(--htRfIa)"
  },
  "colors.inverse.black": {
    "value": "var(--jXCDIP)",
    "variable": "var(--cbLnvO)"
  },
  "colors.inverse.white": {
    "value": "var(--hoiJub)",
    "variable": "var(--jQIXyS)"
  },
  "colors.gradient.purple.level-0": {
    "value": "#3326C8",
    "variable": "var(--itLqyf)"
  },
  "colors.gradient.purple.level-1": {
    "value": "#3326C8",
    "variable": "var(--kAOKli)"
  },
  "colors.gradient.purple.level-2": {
    "value": "#7815DB",
    "variable": "var(--kswjMF)"
  },
  "gradients.programs.vip": {
    "value": "var(--kalFXz)",
    "variable": "var(--hQRBiO)"
  },
  "gradients.programs.promotion": {
    "value": "var(--hHbxkB)",
    "variable": "var(--gvuWva)"
  },
  "colors.colorPalette.50": {
    "value": "var(--bgowFI)",
    "variable": "var(--bgowFI)"
  },
  "colors.colorPalette.100": {
    "value": "var(--iSScQY)",
    "variable": "var(--iSScQY)"
  },
  "colors.colorPalette.200": {
    "value": "var(--bdPmBD)",
    "variable": "var(--bdPmBD)"
  },
  "colors.colorPalette.300": {
    "value": "var(--EuecW)",
    "variable": "var(--EuecW)"
  },
  "colors.colorPalette.400": {
    "value": "var(--dIdJaV)",
    "variable": "var(--dIdJaV)"
  },
  "colors.colorPalette.500": {
    "value": "var(--iOGEjQ)",
    "variable": "var(--iOGEjQ)"
  },
  "colors.colorPalette.600": {
    "value": "var(--ZDNUv)",
    "variable": "var(--ZDNUv)"
  },
  "colors.colorPalette.700": {
    "value": "var(--AiFvO)",
    "variable": "var(--AiFvO)"
  },
  "colors.colorPalette.800": {
    "value": "var(--iCIPjV)",
    "variable": "var(--iCIPjV)"
  },
  "colors.colorPalette.900": {
    "value": "var(--ctQaTU)",
    "variable": "var(--ctQaTU)"
  },
  "colors.colorPalette.0": {
    "value": "var(--fWGYml)",
    "variable": "var(--fWGYml)"
  },
  "colors.colorPalette.25": {
    "value": "var(--hSVyWS)",
    "variable": "var(--hSVyWS)"
  },
  "colors.colorPalette.150": {
    "value": "var(--lgCAFt)",
    "variable": "var(--lgCAFt)"
  },
  "colors.colorPalette.white": {
    "value": "var(--kwEEJq)",
    "variable": "var(--kwEEJq)"
  },
  "colors.colorPalette.black": {
    "value": "var(--lfOvJa)",
    "variable": "var(--lfOvJa)"
  },
  "colors.colorPalette.blue": {
    "value": "var(--jemEav)",
    "variable": "var(--jemEav)"
  },
  "colors.colorPalette": {
    "value": "var(--idUrcU)",
    "variable": "var(--idUrcU)"
  },
  "colors.colorPalette.blue.ex": {
    "value": "var(--huJBvr)",
    "variable": "var(--huJBvr)"
  },
  "colors.colorPalette.ex": {
    "value": "var(--gpDRjs)",
    "variable": "var(--gpDRjs)"
  },
  "colors.colorPalette.blue.dark": {
    "value": "var(--cdsNxi)",
    "variable": "var(--cdsNxi)"
  },
  "colors.colorPalette.dark": {
    "value": "var(--cLysdB)",
    "variable": "var(--cLysdB)"
  },
  "colors.colorPalette.blue.light": {
    "value": "var(--esqfmg)",
    "variable": "var(--esqfmg)"
  },
  "colors.colorPalette.light": {
    "value": "var(--eQrkVj)",
    "variable": "var(--eQrkVj)"
  },
  "colors.colorPalette.red": {
    "value": "var(--hVAWZC)",
    "variable": "var(--hVAWZC)"
  },
  "colors.colorPalette.red.hover": {
    "value": "var(--elFifp)",
    "variable": "var(--elFifp)"
  },
  "colors.colorPalette.hover": {
    "value": "var(--hjJRhX)",
    "variable": "var(--hjJRhX)"
  },
  "colors.colorPalette.green": {
    "value": "var(--kSZRuW)",
    "variable": "var(--kSZRuW)"
  },
  "colors.colorPalette.green.dark": {
    "value": "var(--dTutfn)",
    "variable": "var(--dTutfn)"
  },
  "colors.colorPalette.green.light": {
    "value": "var(--bNxUdN)",
    "variable": "var(--bNxUdN)"
  },
  "colors.colorPalette.green.hover": {
    "value": "var(--gdVWUd)",
    "variable": "var(--gdVWUd)"
  },
  "colors.colorPalette.yellow": {
    "value": "var(--kFXnIx)",
    "variable": "var(--kFXnIx)"
  },
  "colors.colorPalette.yellow.dark": {
    "value": "var(--cPHzMw)",
    "variable": "var(--cPHzMw)"
  },
  "colors.colorPalette.yellow.light": {
    "value": "var(--ibxMSS)",
    "variable": "var(--ibxMSS)"
  },
  "colors.colorPalette.gray.1": {
    "value": "var(--iIenyQ)",
    "variable": "var(--iIenyQ)"
  },
  "colors.colorPalette.1": {
    "value": "var(--ldjTvg)",
    "variable": "var(--ldjTvg)"
  },
  "colors.colorPalette.gray.2": {
    "value": "var(--kRUlQb)",
    "variable": "var(--kRUlQb)"
  },
  "colors.colorPalette.2": {
    "value": "var(--dohdfL)",
    "variable": "var(--dohdfL)"
  },
  "colors.colorPalette.gray.3": {
    "value": "var(--eCxavu)",
    "variable": "var(--eCxavu)"
  },
  "colors.colorPalette.3": {
    "value": "var(--cOLUHe)",
    "variable": "var(--cOLUHe)"
  },
  "colors.colorPalette.gray.4": {
    "value": "var(--hQkNGp)",
    "variable": "var(--hQkNGp)"
  },
  "colors.colorPalette.4": {
    "value": "var(--fSvzFd)",
    "variable": "var(--fSvzFd)"
  },
  "colors.colorPalette.gray.8": {
    "value": "var(--jONjQB)",
    "variable": "var(--jONjQB)"
  },
  "colors.colorPalette.8": {
    "value": "var(--kNaFOd)",
    "variable": "var(--kNaFOd)"
  },
  "colors.colorPalette.gray.23": {
    "value": "var(--kxPzHM)",
    "variable": "var(--kxPzHM)"
  },
  "colors.colorPalette.23": {
    "value": "var(--iHbFYs)",
    "variable": "var(--iHbFYs)"
  },
  "colors.colorPalette.gray.1c": {
    "value": "var(--XZbQb)",
    "variable": "var(--XZbQb)"
  },
  "colors.colorPalette.1c": {
    "value": "var(--igPxTL)",
    "variable": "var(--igPxTL)"
  },
  "colors.colorPalette.gray.d": {
    "value": "var(--iBtYTR)",
    "variable": "var(--iBtYTR)"
  },
  "colors.colorPalette.d": {
    "value": "var(--cMqHld)",
    "variable": "var(--cMqHld)"
  },
  "colors.colorPalette.gray.e": {
    "value": "var(--kjEjhs)",
    "variable": "var(--kjEjhs)"
  },
  "colors.colorPalette.e": {
    "value": "var(--eaTeQg)",
    "variable": "var(--eaTeQg)"
  },
  "colors.colorPalette.social.discord": {
    "value": "var(--fzeNBT)",
    "variable": "var(--fzeNBT)"
  },
  "colors.colorPalette.discord": {
    "value": "var(--daOzDB)",
    "variable": "var(--daOzDB)"
  },
  "colors.colorPalette.social.telegram": {
    "value": "var(--jtwJeC)",
    "variable": "var(--jtwJeC)"
  },
  "colors.colorPalette.telegram": {
    "value": "var(--gAXyTg)",
    "variable": "var(--gAXyTg)"
  },
  "colors.colorPalette.social.twitter": {
    "value": "var(--eUoude)",
    "variable": "var(--eUoude)"
  },
  "colors.colorPalette.twitter": {
    "value": "var(--lhvGWw)",
    "variable": "var(--lhvGWw)"
  },
  "colors.colorPalette.gradient.purple": {
    "value": "var(--cdhzuo)",
    "variable": "var(--cdhzuo)"
  },
  "colors.colorPalette.purple": {
    "value": "var(--hVGqf)",
    "variable": "var(--hVGqf)"
  },
  "colors.colorPalette.gradient.pink": {
    "value": "var(--hfLTce)",
    "variable": "var(--hfLTce)"
  },
  "colors.colorPalette.pink": {
    "value": "var(--cVTnJR)",
    "variable": "var(--cVTnJR)"
  },
  "colors.colorPalette.default.level-0": {
    "value": "var(--eskMAE)",
    "variable": "var(--eskMAE)"
  },
  "colors.colorPalette.level-0": {
    "value": "var(--hFoVIi)",
    "variable": "var(--hFoVIi)"
  },
  "colors.colorPalette.default.level-1": {
    "value": "var(--jYWEkF)",
    "variable": "var(--jYWEkF)"
  },
  "colors.colorPalette.level-1": {
    "value": "var(--iWQpyr)",
    "variable": "var(--iWQpyr)"
  },
  "colors.colorPalette.default.level-2": {
    "value": "var(--dZorW)",
    "variable": "var(--dZorW)"
  },
  "colors.colorPalette.level-2": {
    "value": "var(--keEGWI)",
    "variable": "var(--keEGWI)"
  },
  "colors.colorPalette.default.level-3": {
    "value": "var(--bnAkD)",
    "variable": "var(--bnAkD)"
  },
  "colors.colorPalette.level-3": {
    "value": "var(--bcBMbp)",
    "variable": "var(--bcBMbp)"
  },
  "colors.colorPalette.default.level-4": {
    "value": "var(--nGSPU)",
    "variable": "var(--nGSPU)"
  },
  "colors.colorPalette.level-4": {
    "value": "var(--lfyiFy)",
    "variable": "var(--lfyiFy)"
  },
  "colors.colorPalette.default.level-5": {
    "value": "var(--fUsKzV)",
    "variable": "var(--fUsKzV)"
  },
  "colors.colorPalette.level-5": {
    "value": "var(--bhDSWL)",
    "variable": "var(--bhDSWL)"
  },
  "colors.colorPalette.accent.info": {
    "value": "var(--gEZyZA)",
    "variable": "var(--gEZyZA)"
  },
  "colors.colorPalette.info": {
    "value": "var(--khMeQD)",
    "variable": "var(--khMeQD)"
  },
  "colors.colorPalette.accent.info.hover": {
    "value": "var(--cPqZZr)",
    "variable": "var(--cPqZZr)"
  },
  "colors.colorPalette.info.hover": {
    "value": "var(--hDZENI)",
    "variable": "var(--hDZENI)"
  },
  "colors.colorPalette.accent.sell": {
    "value": "var(--fAYXzk)",
    "variable": "var(--fAYXzk)"
  },
  "colors.colorPalette.sell": {
    "value": "var(--gOqiKT)",
    "variable": "var(--gOqiKT)"
  },
  "colors.colorPalette.accent.sell.hover": {
    "value": "var(--elZYVz)",
    "variable": "var(--elZYVz)"
  },
  "colors.colorPalette.sell.hover": {
    "value": "var(--gFAlLc)",
    "variable": "var(--gFAlLc)"
  },
  "colors.colorPalette.accent.new": {
    "value": "var(--lcujgC)",
    "variable": "var(--lcujgC)"
  },
  "colors.colorPalette.new": {
    "value": "var(--gowzqN)",
    "variable": "var(--gowzqN)"
  },
  "colors.colorPalette.accent.new.hover": {
    "value": "var(--krUKFJ)",
    "variable": "var(--krUKFJ)"
  },
  "colors.colorPalette.new.hover": {
    "value": "var(--fzHtDi)",
    "variable": "var(--fzHtDi)"
  },
  "colors.colorPalette.accent.buy": {
    "value": "var(--dOiVQ)",
    "variable": "var(--dOiVQ)"
  },
  "colors.colorPalette.buy": {
    "value": "var(--haJjav)",
    "variable": "var(--haJjav)"
  },
  "colors.colorPalette.accent.buy.hover": {
    "value": "var(--keZaxr)",
    "variable": "var(--keZaxr)"
  },
  "colors.colorPalette.buy.hover": {
    "value": "var(--cBsydY)",
    "variable": "var(--cBsydY)"
  },
  "colors.colorPalette.accent.promotion": {
    "value": "var(--cDqSVF)",
    "variable": "var(--cDqSVF)"
  },
  "colors.colorPalette.promotion": {
    "value": "var(--dSPRpC)",
    "variable": "var(--dSPRpC)"
  },
  "colors.colorPalette.accent.promotion.hover": {
    "value": "var(--egZxZu)",
    "variable": "var(--egZxZu)"
  },
  "colors.colorPalette.promotion.hover": {
    "value": "var(--eckTgR)",
    "variable": "var(--eckTgR)"
  },
  "colors.colorPalette.accent.VIP": {
    "value": "var(--lgAxqh)",
    "variable": "var(--lgAxqh)"
  },
  "colors.colorPalette.VIP": {
    "value": "var(--jOlTYm)",
    "variable": "var(--jOlTYm)"
  },
  "colors.colorPalette.state.negative": {
    "value": "var(--gADQLo)",
    "variable": "var(--gADQLo)"
  },
  "colors.colorPalette.negative": {
    "value": "var(--cdjrCi)",
    "variable": "var(--cdjrCi)"
  },
  "colors.colorPalette.state.negative.hover": {
    "value": "var(--dFCUgH)",
    "variable": "var(--dFCUgH)"
  },
  "colors.colorPalette.negative.hover": {
    "value": "var(--irnKXp)",
    "variable": "var(--irnKXp)"
  },
  "colors.colorPalette.state.positive": {
    "value": "var(--cZSZNE)",
    "variable": "var(--cZSZNE)"
  },
  "colors.colorPalette.positive": {
    "value": "var(--eedBlu)",
    "variable": "var(--eedBlu)"
  },
  "colors.colorPalette.state.positive.hover": {
    "value": "var(--eEeSYj)",
    "variable": "var(--eEeSYj)"
  },
  "colors.colorPalette.positive.hover": {
    "value": "var(--byuKcJ)",
    "variable": "var(--byuKcJ)"
  },
  "colors.colorPalette.state.warning": {
    "value": "var(--kEfByl)",
    "variable": "var(--kEfByl)"
  },
  "colors.colorPalette.warning": {
    "value": "var(--hmRtaX)",
    "variable": "var(--hmRtaX)"
  },
  "colors.colorPalette.state.warning.hover": {
    "value": "var(--cDpBUO)",
    "variable": "var(--cDpBUO)"
  },
  "colors.colorPalette.warning.hover": {
    "value": "var(--gYlbQY)",
    "variable": "var(--gYlbQY)"
  },
  "colors.colorPalette.interaction.hover": {
    "value": "var(--cXFMIs)",
    "variable": "var(--cXFMIs)"
  },
  "colors.colorPalette.interaction.disabled": {
    "value": "var(--iEdiyS)",
    "variable": "var(--iEdiyS)"
  },
  "colors.colorPalette.disabled": {
    "value": "var(--gTYnIJ)",
    "variable": "var(--gTYnIJ)"
  },
  "colors.colorPalette.legacy.default.level-0": {
    "value": "var(--NIyFs)",
    "variable": "var(--NIyFs)"
  },
  "colors.colorPalette.legacy.default.level-1": {
    "value": "var(--cPAhQh)",
    "variable": "var(--cPAhQh)"
  },
  "colors.colorPalette.legacy.default.level-2": {
    "value": "var(--cIAFGS)",
    "variable": "var(--cIAFGS)"
  },
  "colors.colorPalette.legacy.default.level-3": {
    "value": "var(--eKsoRH)",
    "variable": "var(--eKsoRH)"
  },
  "colors.colorPalette.legacy.default.level-4": {
    "value": "var(--bZqZJo)",
    "variable": "var(--bZqZJo)"
  },
  "colors.colorPalette.legacy.default.level-5": {
    "value": "var(--ebiIUd)",
    "variable": "var(--ebiIUd)"
  },
  "colors.colorPalette.legacy.accent.info": {
    "value": "var(--jgSsAg)",
    "variable": "var(--jgSsAg)"
  },
  "colors.colorPalette.legacy.accent.promotion": {
    "value": "var(--dzIQZx)",
    "variable": "var(--dzIQZx)"
  },
  "colors.colorPalette.legacy.accent.vip": {
    "value": "var(--klhWVJ)",
    "variable": "var(--klhWVJ)"
  },
  "colors.colorPalette.accent.vip": {
    "value": "var(--fhzZGN)",
    "variable": "var(--fhzZGN)"
  },
  "colors.colorPalette.vip": {
    "value": "var(--eolADG)",
    "variable": "var(--eolADG)"
  },
  "colors.colorPalette.legacy.state.negative": {
    "value": "var(--ijcZAY)",
    "variable": "var(--ijcZAY)"
  },
  "colors.colorPalette.legacy.state.positive": {
    "value": "var(--dpXAXo)",
    "variable": "var(--dpXAXo)"
  },
  "colors.colorPalette.legacy.state.warning": {
    "value": "var(--cBtVUB)",
    "variable": "var(--cBtVUB)"
  },
  "colors.colorPalette.legacy.interaction.hover": {
    "value": "var(--iAQkFw)",
    "variable": "var(--iAQkFw)"
  },
  "colors.colorPalette.legacy.interaction.disabled": {
    "value": "var(--hnmdye)",
    "variable": "var(--hnmdye)"
  },
  "colors.colorPalette.accent.primary": {
    "value": "var(--QBMLq)",
    "variable": "var(--QBMLq)"
  },
  "colors.colorPalette.primary": {
    "value": "var(--gbCbhR)",
    "variable": "var(--gbCbhR)"
  },
  "colors.colorPalette.accent.primary.hover": {
    "value": "var(--fHxCht)",
    "variable": "var(--fHxCht)"
  },
  "colors.colorPalette.primary.hover": {
    "value": "var(--cFYVhW)",
    "variable": "var(--cFYVhW)"
  },
  "colors.colorPalette.accent.primary.tint": {
    "value": "var(--loGHWU)",
    "variable": "var(--loGHWU)"
  },
  "colors.colorPalette.primary.tint": {
    "value": "var(--cZFiWT)",
    "variable": "var(--cZFiWT)"
  },
  "colors.colorPalette.tint": {
    "value": "var(--etRmdq)",
    "variable": "var(--etRmdq)"
  },
  "colors.colorPalette.accent.secondary": {
    "value": "var(--deETfU)",
    "variable": "var(--deETfU)"
  },
  "colors.colorPalette.secondary": {
    "value": "var(--dDofdL)",
    "variable": "var(--dDofdL)"
  },
  "colors.colorPalette.accent.secondary.hover": {
    "value": "var(--kxTZkr)",
    "variable": "var(--kxTZkr)"
  },
  "colors.colorPalette.secondary.hover": {
    "value": "var(--bxsRws)",
    "variable": "var(--bxsRws)"
  },
  "colors.colorPalette.accent.secondary.tint": {
    "value": "var(--etbNui)",
    "variable": "var(--etbNui)"
  },
  "colors.colorPalette.secondary.tint": {
    "value": "var(--kODBVF)",
    "variable": "var(--kODBVF)"
  },
  "colors.colorPalette.accent.secondary.tint.hover": {
    "value": "var(--iSOKEl)",
    "variable": "var(--iSOKEl)"
  },
  "colors.colorPalette.secondary.tint.hover": {
    "value": "var(--kjSrIy)",
    "variable": "var(--kjSrIy)"
  },
  "colors.colorPalette.tint.hover": {
    "value": "var(--dupfYV)",
    "variable": "var(--dupfYV)"
  },
  "colors.colorPalette.accent.sell.tint": {
    "value": "var(--vUMTG)",
    "variable": "var(--vUMTG)"
  },
  "colors.colorPalette.sell.tint": {
    "value": "var(--eajVIF)",
    "variable": "var(--eajVIF)"
  },
  "colors.colorPalette.accent.new.tint": {
    "value": "var(--cKJkdY)",
    "variable": "var(--cKJkdY)"
  },
  "colors.colorPalette.new.tint": {
    "value": "var(--Xvpgv)",
    "variable": "var(--Xvpgv)"
  },
  "colors.colorPalette.accent.buy.tint": {
    "value": "var(--izsFry)",
    "variable": "var(--izsFry)"
  },
  "colors.colorPalette.buy.tint": {
    "value": "var(--dmuKLR)",
    "variable": "var(--dmuKLR)"
  },
  "colors.colorPalette.accent.promotion.tint": {
    "value": "var(--hOHfVf)",
    "variable": "var(--hOHfVf)"
  },
  "colors.colorPalette.promotion.tint": {
    "value": "var(--DvLcA)",
    "variable": "var(--DvLcA)"
  },
  "colors.colorPalette.state.negative.tint": {
    "value": "var(--jhRHWO)",
    "variable": "var(--jhRHWO)"
  },
  "colors.colorPalette.negative.tint": {
    "value": "var(--isyHLU)",
    "variable": "var(--isyHLU)"
  },
  "colors.colorPalette.state.positive.tint": {
    "value": "var(--gVsYKa)",
    "variable": "var(--gVsYKa)"
  },
  "colors.colorPalette.positive.tint": {
    "value": "var(--iXaSMs)",
    "variable": "var(--iXaSMs)"
  },
  "colors.colorPalette.state.warning.tint": {
    "value": "var(--dZqzRf)",
    "variable": "var(--dZqzRf)"
  },
  "colors.colorPalette.warning.tint": {
    "value": "var(--iuUeyl)",
    "variable": "var(--iuUeyl)"
  },
  "colors.colorPalette.interaction.dim": {
    "value": "var(--giLtGm)",
    "variable": "var(--giLtGm)"
  },
  "colors.colorPalette.dim": {
    "value": "var(--llGnEd)",
    "variable": "var(--llGnEd)"
  },
  "colors.colorPalette.legacy.accent.primary": {
    "value": "var(--lgjBbi)",
    "variable": "var(--lgjBbi)"
  },
  "colors.colorPalette.legacy.accent.primary.hover": {
    "value": "var(--hJrDXd)",
    "variable": "var(--hJrDXd)"
  },
  "colors.colorPalette.legacy.accent.secondary": {
    "value": "var(--fZrKpo)",
    "variable": "var(--fZrKpo)"
  },
  "colors.colorPalette.legacy.accent.secondary.hover": {
    "value": "var(--kjdxoP)",
    "variable": "var(--kjdxoP)"
  },
  "colors.colorPalette.legacy.accent.buy": {
    "value": "var(--ecldmo)",
    "variable": "var(--ecldmo)"
  },
  "colors.colorPalette.legacy.accent.buy.hover": {
    "value": "var(--PdXDr)",
    "variable": "var(--PdXDr)"
  },
  "colors.colorPalette.legacy.accent.sell": {
    "value": "var(--cUlZPY)",
    "variable": "var(--cUlZPY)"
  },
  "colors.colorPalette.legacy.accent.sell.hover": {
    "value": "var(--eVlcML)",
    "variable": "var(--eVlcML)"
  },
  "colors.colorPalette.legacy.interaction.dim": {
    "value": "var(--ctzYtO)",
    "variable": "var(--ctzYtO)"
  },
  "colors.colorPalette.legacy.accent.short": {
    "value": "var(--jLPmNM)",
    "variable": "var(--jLPmNM)"
  },
  "colors.colorPalette.accent.short": {
    "value": "var(--drXovM)",
    "variable": "var(--drXovM)"
  },
  "colors.colorPalette.short": {
    "value": "var(--iURgPL)",
    "variable": "var(--iURgPL)"
  },
  "colors.colorPalette.legacy.accent.long": {
    "value": "var(--gCGsIc)",
    "variable": "var(--gCGsIc)"
  },
  "colors.colorPalette.accent.long": {
    "value": "var(--ghRPMk)",
    "variable": "var(--ghRPMk)"
  },
  "colors.colorPalette.long": {
    "value": "var(--jbifCb)",
    "variable": "var(--jbifCb)"
  },
  "colors.colorPalette.purple.level-0": {
    "value": "var(--eWUFNN)",
    "variable": "var(--eWUFNN)"
  },
  "colors.colorPalette.purple.level-1": {
    "value": "var(--gAnRYk)",
    "variable": "var(--gAnRYk)"
  },
  "colors.colorPalette.purple.level-2": {
    "value": "var(--jsCKeX)",
    "variable": "var(--jsCKeX)"
  }
}

export function token(path, fallback) {
  return tokens[path]?.value || fallback
}

function tokenVar(path, fallback) {
  return tokens[path]?.variable || fallback
}

token.var = tokenVar